export const footerSections = [
    {
        title: "Help center",
        links: [
            "Frequently Asked Questions",
            "Driver Training Platform",
            "Support",
        ]
    },
    {
        title: "Healthy 24",
        links: [
            "C.G.U",
            "Privacy",
            "Press",
            "Partnership",
        ]
    }
]